module.exports = __webpack_public_path__ + "static/media/as.5a2e3101.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/as.png
// module id = 1785
// module chunks = 0